"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withUseCalendarSettings = exports.hasCalendarSettingsChanged = exports.useCalendarSettings = exports.TimeOffShowAtBottom = exports.TimeOffShowTimeDataAs = exports.ShiftColorBasedOn = exports.ShiftShowAtBottom = exports.ShiftShowTimeDataAs = void 0;
const graphql_1 = require("@app/gql-types/graphql");
const store_1 = require("@app/store");
const react_1 = __importDefault(require("react"));
const is_defined_1 = require("./is-defined");
const user_option_parser_1 = require("./user-option-parser");
var ShiftShowTimeDataAs;
(function (ShiftShowTimeDataAs) {
    ShiftShowTimeDataAs["Period"] = "period";
    ShiftShowTimeDataAs["Duration"] = "duration";
})(ShiftShowTimeDataAs || (exports.ShiftShowTimeDataAs = ShiftShowTimeDataAs = {}));
var ShiftShowAtBottom;
(function (ShiftShowAtBottom) {
    ShiftShowAtBottom["Position"] = "position";
    ShiftShowAtBottom["Duration"] = "duration";
    ShiftShowAtBottom["Locality"] = "locality";
    ShiftShowAtBottom["Nothing"] = "nothing";
})(ShiftShowAtBottom || (exports.ShiftShowAtBottom = ShiftShowAtBottom = {}));
var ShiftColorBasedOn;
(function (ShiftColorBasedOn) {
    ShiftColorBasedOn["Position"] = "position";
    ShiftColorBasedOn["RON"] = "ron";
})(ShiftColorBasedOn || (exports.ShiftColorBasedOn = ShiftColorBasedOn = {}));
var TimeOffShowTimeDataAs;
(function (TimeOffShowTimeDataAs) {
    TimeOffShowTimeDataAs["Period"] = "period";
    TimeOffShowTimeDataAs["Duration"] = "duration";
})(TimeOffShowTimeDataAs || (exports.TimeOffShowTimeDataAs = TimeOffShowTimeDataAs = {}));
var TimeOffShowAtBottom;
(function (TimeOffShowAtBottom) {
    TimeOffShowAtBottom["Shortcut"] = "shortcut";
    TimeOffShowAtBottom["Name"] = "name";
    TimeOffShowAtBottom["Nothing"] = "none";
})(TimeOffShowAtBottom || (exports.TimeOffShowAtBottom = TimeOffShowAtBottom = {}));
const useCalendarSettings = () => {
    const userOptions = (0, store_1.useRootSelector)((state) => state.me.options?.filter(is_defined_1.isValue) ?? []);
    const userOptionsParser = react_1.default.useMemo(() => new user_option_parser_1.UserOptionParser(userOptions), [userOptions]);
    const calendarViewSettings = react_1.default.useMemo(() => ({
        // calendar view
        // displayRowTemplates
        calendarRowTemplates: userOptionsParser.getBoolean('calendarRowTemplates') ?? true,
        // displayRowUnassigned in old settings
        calendarRowUnassigned: userOptionsParser.getBoolean('calendarRowUnassigned') ?? true,
        // displayRowOffers in old settings
        calendarRowOffers: userOptionsParser.getBoolean('calendarRowOffers') ?? true,
        // displayStatistics in old settings
        calendarShowStatistics: userOptionsParser.getBoolean('calendarShowStatistics') ?? false,
        // displayCapacities in old settings
        calendarShowCapacities: userOptionsParser.getBoolean('calendarShowCapacities') ?? false,
        // shift settings
        shiftShowTimeDataAs: userOptionsParser.getEnum('shiftShowTimeDataAs', ShiftShowTimeDataAs) ??
            ShiftShowTimeDataAs.Period,
        shiftColorBasedOn: userOptionsParser.getEnum('shiftColorBasedOn', ShiftColorBasedOn) ??
            ShiftColorBasedOn.Position,
        shiftShowAtBottom: userOptionsParser.getEnum('shiftShowAtBottom', ShiftShowAtBottom) ??
            ShiftShowAtBottom.Position,
        // timeoff settings
        timeOffShowTimeDataAs: userOptionsParser.getEnum('timeOffShowTimeDataAs', TimeOffShowTimeDataAs) ??
            TimeOffShowTimeDataAs.Period,
        timeOffShowAtBottom: userOptionsParser.getEnum('timeOffShowAtBottom', TimeOffShowAtBottom) ??
            TimeOffShowAtBottom.Shortcut,
        timeOffDefaultInclusion: userOptionsParser.getEnum('timeOffDefaultInclusion', graphql_1.TimeOffWorkMinutesInclusion) ?? graphql_1.TimeOffWorkMinutesInclusion.ShiftDays,
        timeOffWorkMinutesBy: userOptionsParser.getEnum('timeOffWorkMinutesBy', graphql_1.TimeOffWorkMinutesBy) ??
            graphql_1.TimeOffWorkMinutesBy.Shift,
        timeOffCustomInclusion: userOptionsParser.getNumber('timeOffCustomInclusion') ?? 0,
    }), [userOptionsParser]);
    return calendarViewSettings;
};
exports.useCalendarSettings = useCalendarSettings;
const hasCalendarSettingsChanged = (a, b) => {
    return (a.calendarRowTemplates !== b.calendarRowTemplates ||
        a.calendarRowUnassigned !== b.calendarRowUnassigned ||
        a.calendarRowOffers !== b.calendarRowOffers ||
        a.calendarShowStatistics !== b.calendarShowStatistics ||
        a.calendarShowCapacities !== b.calendarShowCapacities ||
        a.shiftShowTimeDataAs !== b.shiftShowTimeDataAs ||
        a.shiftShowAtBottom !== b.shiftShowAtBottom ||
        a.shiftColorBasedOn !== b.shiftColorBasedOn ||
        a.timeOffShowTimeDataAs !== b.timeOffShowTimeDataAs ||
        a.timeOffShowAtBottom !== b.timeOffShowAtBottom ||
        a.timeOffDefaultInclusion !== b.timeOffDefaultInclusion ||
        a.timeOffWorkMinutesBy !== b.timeOffWorkMinutesBy ||
        a.timeOffCustomInclusion !== b.timeOffCustomInclusion);
};
exports.hasCalendarSettingsChanged = hasCalendarSettingsChanged;
const withUseCalendarSettings = (WrappedComponent) => {
    const ComponentWithCalendarSettings = (props) => {
        const calendarSettings = (0, exports.useCalendarSettings)();
        return react_1.default.createElement(WrappedComponent, { ...props, calendarSettings: calendarSettings });
    };
    ComponentWithCalendarSettings.displayName = `withUseCalendarViewSettings(${WrappedComponent.displayName ?? 'Component'})`;
    return ComponentWithCalendarSettings;
};
exports.withUseCalendarSettings = withUseCalendarSettings;
